export * from './VariantLabel'
